import * as Yup from "yup";

import { passwordSchema } from "~form/shared";

export type LoginValues = {
  password: {
    email: string;
    password: string;
  };
  link: {
    email: string;
  };
};

export const getFormValues = (
  { email, password }: Partial<LoginValues["password"]>,
  formType: "password" | "link"
) =>
  ({
    password: {
      email: email ?? "",
      password: password ?? "",
    },
    link: {
      email: email ?? "",
    },
  })[formType];

export const validationSchema = (formType: "password" | "link") =>
  ({
    password: Yup.object().shape({
      email: Yup.string().email().required(),
      password: passwordSchema,
    }),
    link: Yup.object().shape({
      email: Yup.string().email().required(),
    }),
  })[formType];
